import AApplicationSummaryItem from './index.vue';

AApplicationSummaryItem.install = app => {
  app.component(AApplicationSummaryItem.name, AApplicationSummaryItem);
};

export default AApplicationSummaryItem;
